export class Role {
    public roleId: string;
    public roleName: string;
}
